module.exports = __webpack_public_path__ + "img/eth-blocks-6.c29b01cd.jpg";